// src/components/AgeretProductDetail.jsx

import React, { useState } from "react";
import "../assets/css/AgeretProductDetail.css";
import mainImage from "../assets/images/allproducts/Solarite2.png";
import thumb1 from "../assets/images/All-Products/Soralite2.png";
import thumb2 from "../assets/images/allproducts/Solarite2.png";
import thumb3 from "../assets/images/All-Products/Soralite.png";
import thumb4 from "../assets/images/New-Products/new/solarite.jpeg";
import howToUseThumb from "../assets/images/skin-breadcrum.jpg";
import howToUseVideo from "../assets/Video/meical video.mp4";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";

const AgeretProductDetails = () => {
  const [selectedImage, setSelectedImage] = useState(mainImage);
  const [activeTab, setActiveTab] = useState("benefits");
  const [showVideo, setShowVideo] = useState(false);

  return (
    <>

      <BreadcrumbSection
        title="Empowering Confidence Through Skin Health."
        // subtitle="Committed to Excellence:"
        breadcrumbItems={[
          { label: "Home", to: "/" }, { label: "Skin Care", to: "/Skin-Care-Products" },

        ]}
        backgroundImage={BredcrumpImage}
      />

      <section className="product-details-section">

        <div className="container product-container">
          {/* Product Image and Details */}
          <div className="product-info">
            <div className="product-image-section">
              <img src={selectedImage} alt="Ageret Product" className="main-image" />
              <div className="thumbnail-row">
                {[thumb4, thumb2, thumb3].map((img, i) => (
                  <img
                    key={i}
                    src={img}
                    alt={`Thumbnail ${i + 1}`}
                    className={`thumbnail ${selectedImage === img ? "active-thumb" : ""}`}
                    onClick={() => setSelectedImage(img)}
                  />
                ))}
              </div>
            </div>

            <div className="product-description">
              <h2>SoraLite</h2>
              <p className="sub-heading text-muted">Synergistic combination for the treatment of mild to moderate plaque psoriasis. </p>
              <h5>Product Overview</h5>
              <p>
                <ul>
                  <li>A topical anhydrous combination solution used for the treatment of mild to moderate plaque psoriasis.</li>
                  <li>SoraLite solution is indicated for managing mild-to-moderate plaque psoriasis characterized by red, scaly, itchy, and dry patches on the skin and scalp caused by increased skin cell production.</li>
                </ul>

              </p>
            </div>
          </div>

          {/* How To Use Section */}
          {/* <div className="how-to-use-section" data-aos="fade-up">
            <div
              className="how-to-use-content"
              style={{
                backgroundImage: `url(${howToUseThumb})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            >
              <div className="text-content">
                <h3>
                  How To Use <span className="highlight">SoraLite ?</span>
                </h3>
                <p>
                  Use this medicine in the dose and duration as advised by your doctor. Check the label for directions before use
                </p>
              </div>
              <div className="video-thumbnail-wrapper" onClick={() => setShowVideo(true)}>
                <div className="video-thumbnail">
                  <i className="bi bi-play-fill play-icon"></i>
                </div>
              </div>
            </div>
          </div> */}

          {/* Video Popup Modal */}
          {showVideo && (
            <div className="video-popup">
              <div className="video-container">
                <video controls autoPlay>
                  <source src={howToUseVideo} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Uncomment this block to use YouTube later */}
                {/*
              <iframe
                src="https://www.youtube.com/embed/VIDEO_ID?autoplay=1"
                title="How to Use Ageret"
                frameBorder="0"
                allow="autoplay; encrypted-media"
                allowFullScreen
              ></iframe>
              */}

                <button className="close-btn" onClick={() => setShowVideo(false)}>
                  &times;
                </button>
              </div>
            </div>
          )}

          {/* Accordion Section */}
          <div className="accordion-section">
            <div className="accordion-tabs">
              {["benefits", "application", "ingredients"].map((tab) => (
                <button
                  key={tab}
                  className={`accordion-tab ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab === "benefits"
                    ? "BENEFITS"
                    : tab === "application"
                      ? "APPLICATION GUIDELINES"
                      : tab === "ingredients"
                        ? "INGREDIENTS"
                        : "BEFORE–AFTER"}
                </button>
              ))}
            </div>

            <div className="accordion-content">
              {activeTab === "benefits" && (
                <div className="tab-content fade-in">
                  <ul>
                    <li>Combination therapy of SoraLite solution stands superior by providing synergistic effects.</li>
                    <li>SoraLite solution reduces psoriatic symptoms rapidly and minimizes the duration of therapy.</li>
                    <li>SoraLite solution reduces adverse effects associated with long-term use of topical corticosteroids or calcipotriol alone.</li>
                    <li>SoraLite solution is a clinically proven, paraben-free, and fragrance-free formulation.</li>
                  </ul>

                </div>
              )}
              {activeTab === "application" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>Apply a thin layer to the affected area as instructed by the doctor.</li>
                      <li>Follow all the usage instructions mentioned on the label or the package insert.</li>
                      <li>Do not apply in larger or smaller quantities than recommended.</li>
                      <li>Report any unusual signs and symptoms to the doctor.</li>
                    </ul>

                  </p>
                </div>
              )}
              {activeTab === "ingredients" && (
                <div className="tab-content fade-in">
                  <p>
                    <ul>
                      <li>
                        <strong>Calcipotriol 0.005%:</strong> Calcipotriol is a synthetic derivative of calcitriol, a synthetic form of vitamin D. It is safe for long-term application in psoriatic skin conditions. Calcipotriol mainly modulates T-cell gene transcription, which reduces keratinocyte proliferation commonly seen in psoriasis.
                      </li>
                      <li>
                        <strong>Clobetasol Propionate 0.05%:</strong> Clobetasol propionate has strong immunosuppressive capacity, providing anti-inflammatory, anti-pruritic, and vasoconstrictive properties. It enables an intermittent treatment schedule due to prolonged remission rates. It also modulates immune response by controlling type 3 and type 4 hypersensitivity reactions.
                      </li>
                    </ul>

                  </p>
                </div>
              )}



            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default AgeretProductDetails;
